import axios from "axios";

const instance = axios.create();
instance.defaults.withCredentials = true
instance.defaults.headers.common['X-CSRF-TOKEN'] = window.appConfig.token;

export default instance;
